const d =
	'M321-250h318v-69H321v69Zm0-169h319v-68H321v68ZM229-59q-35.775 0-63.388-27.112Q138-113.225 138-150v-660q0-37.188 27.612-64.594Q193.225-902 229-902h364l230 228v524q0 36.775-27.906 63.888Q767.188-59 731-59H229Zm316-569h186L545-810v182Z';

export default d;
